import { registerPlugin } from "@capacitor/core";
import { apiOrigin, isNativeApp } from "./native.ts";

const externalLinks = registerPlugin<{ open(options: { url: string }): Promise<void> }>("ExternalLinks");

/** The bundled app has a localhost origin; legal pages live on the production site. */
export function installNativeExternalLinks(): void {
  if (!isNativeApp()) return;
  document.addEventListener("click", (event) => {
    const anchor = (event.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
    if (!anchor || event.defaultPrevented) return;
    const raw = anchor.getAttribute("href");
    if (!raw) return;
    const url = new URL(raw, apiOrigin());
    if (url.protocol !== "https:" && url.protocol !== "http:") return;
    event.preventDefault();
    void externalLinks.open({ url: url.href }).catch(() => {});
  }, { capture: true });
}
